<app-fleet-page-header
  (clearSearch)="model.setSearch('')"
  (searchChanged)="model.setSearch($event)"
  (sortChanged)="model.setOrder($event, true)"
  [columns]="state.columns$ | async"
  [counter]="(state.count$ | async) ?? 0"
  [defaultSortOrder]="state.defaultSortOrder$ | async"
  [search]="state.search$ | async"
  [showMobileMenuButton]="false"
  [sortOrder]="state.gridSortOrder$ | async"
  [templates]="{ actionButtons, countIcon }"
  titleText="ti-admin.accounts.title"
></app-fleet-page-header>

<ng-template #countIcon>
  <app-icon-fleets-count [height]="22" [width]="22"></app-icon-fleets-count>
</ng-template>

<ng-template #actionButtons let-isMobile="isMobile">
  <p-button
    (click)="model.openFleetLaunchDialog()"
    [appCheckAccess]="[Resource.TSP, Action.Create]"
    [icon]="isMobile ? 'pi' : ''"
    [severity]="isMobile ? 'secondary' : 'primary'"
    class="header-button h--40 p--18 text-14 fw-500"
  >
    <app-icon-plus [height]="20" [width]="20" class="icon"></app-icon-plus>
    @if (!isMobile) {
      {{ 'ti-admin.accounts.grid.launch-new-btn' | translate }}
    }
  </p-button>
</ng-template>

@if (model.scope$ | async; as scope) {
  @if (scope.requested !== null) {
    <section class="scope-bar">
      <div [class.rejected]="scope.tspId === null" class="chip scope-chip text-13 fw-500">
        @if (scope.tspId === null) {
          <app-icon-alert-circle [height]="16" [width]="16"></app-icon-alert-circle>
        }
        <span>{{ TSP_ID_LABEL }}: {{ scope.tspId ?? scope.requested }}</span>
        <button (click)="clearScope()" class="scope-remove clickable" type="button">
          <app-icon-close [height]="16" [width]="16"></app-icon-close>
        </button>
      </div>
    </section>
  }
}

<app-ti-accounts-grid
  (edit)="model.openEditDialog($event)"
  (rowClicked)="model.openEditDialog($event)"
  [class.hidden]="model.state.selectedItem$ | async"
></app-ti-accounts-grid>

@if (model.showLaunchForm$ | async) {
  <app-ti-launch-account-dialog
    (cancelled)="model.showLaunchForm$.next(false)"
    (launched)="model.launchAccount($event)"
    [errorMessage]="(state.errorMessage$ | async) || ''"
    [opened]="true"
    [processing]="!!(model.launchingAccount$ | async)"
  ></app-ti-launch-account-dialog>
}

@if (model.showEditForm$ | async) {
  <app-ti-edit-account-dialog
    (cancelled)="model.showEditForm$.next(false)"
    (updated)="model.editAccount($event)"
    [account]="state.selectedItem$ | async"
    [errorMessage]="(state.errorMessage$ | async) || ''"
    [opened]="true"
    [processing]="!!(model.editingAccount$ | async)"
  ></app-ti-edit-account-dialog>
}
